import * as R from 'ramda';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { InfiniteDataQueryFnUtils } from '../../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { useInfiniteListWithCheckbox } from '../../../../hooks/useInfiniteListWithCheckbox/useInfiniteListWithCheckbox';
import useSearchParams from '../../../../hooks/useSearchParams';
import { INFINITE_SCROLL_ROOT_MARGIN_EXPLORE } from '../../../../utils/constants';
import { MY_NETWORK_EXPLORE_FILTERS_KEYS } from '../../myNetworkFilters.utils';
import { findExplore } from '../myNetworkExplore.repository';

const EXPLORE_PAGE_LIMIT = 20;

const useMyNetworkExploreList = () => {
  const { searchParams } = useSearchParams();

  const { query } = useInfiniteListWithCheckbox({
    limit: EXPLORE_PAGE_LIMIT,
    cacheKey: 'my-network-explore',
    defaultOrderBy: {},
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCount(findExplore),
    queryFnParams: R.pick(MY_NETWORK_EXPLORE_FILTERS_KEYS, searchParams),
  });

  const explores = query.pagesData ?? [];
  const isLoading = query.isLoading || query.isFetchingNextPage;
  const hasNextPage = !!query.hasNextPage;

  const [sentinelRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore: query.fetchNextPage,
    rootMargin: INFINITE_SCROLL_ROOT_MARGIN_EXPLORE,
  });

  return {
    explores,
    isLoading,
    isEmpty: !query.isLoading && explores.length === 0,
    hasNextPage,
    sentinelRef,
    reload: query.refetch,
  };
};

export default useMyNetworkExploreList;
